<template>
    <div>
        <MaterialDetailCom v-if="show_type==1&&show_pop" v-model="show_pop" :id="show_id" />
    </div>
</template>

<script>
import MaterialDetailCom from '../Demand/MaterialDetailCom.vue'
import EventBus from '../../utils/eventbus'
export default {
    data(){return{
        show_pop:false,
        show_type:0,
        show_id:0,
    }},
    components:{
        MaterialDetailCom,
    },
    mounted(){
        EventBus.$on('pop_material',(_data)=>{
            this.show_type=1;
            this.show_pop=true;
            this.show_id=_data;
        });
        // EventBus.$on('pop_company',(_data)=>{
        //     this.show_type=2;
        //     this.show_pop=true;
        //     this.show_id=_data;
        // });
       
    },
    methods:{
    }
}
</script>